// src/features/manual/i18n/es.ts

export default {
  name: 'Manual de uso',
  title: 'Manual de uso',
  parts: {
    'getting-started': 'Primeros pasos',
    reception: 'Recepción',
    management: 'Dirección',
    finance: 'Finanzas',
    incidents: 'Incidencias',
    systems: 'Sistemas',
    administration: 'Administración',
    reference: 'Referencia',
    other: 'Otros',
  },
  rail: {
    label: 'Índice del manual',
    toggle: 'Índice del manual',
    inChapter: 'En este capítulo',
  },
  search: {
    label: 'Buscar en el manual',
    placeholder: 'Buscar en el manual',
    clear: 'Vaciar la búsqueda',
    results: 'Resultados de la búsqueda',
    tooShort: 'Escriba al menos %{min} letras.',
    empty: 'No hay resultados para "%{query}"',
    emptyHint: 'Pruebe con menos palabras o con otra forma de decirlo. Deben aparecer todas en la misma sección.',
    error: 'No se ha podido buscar en el manual.',
    retry: 'Reintentar',
    count: '%{smart_count} resultado |||| %{smart_count} resultados',
    more: 'Se muestran los %{shown} primeros de %{total}. Añada palabras para afinar.',
  },
  lang: {
    label: 'Idioma del manual',
    es: 'ES',
    en: 'EN',
  },
  meta: {
    updated: 'Actualizado el %{date}',
  },
  staff: {
    label: 'Solo personal de Roommatik',
    chapter: 'Capítulo solo para el personal de Roommatik',
  },
  state: {
    empty: 'El manual todavía no tiene capítulos publicados.',
    notFound: 'Este capítulo no existe.',
    imageMissing: 'Imagen no disponible',
  },
  image: {
    enlarge: 'Abrir la imagen a tamaño completo',
  },
  help: {
    button: 'Ver en el manual',
    hint: 'Abrir el manual en la sección que explica esta pantalla',
  },
};
